<template>
    <div v-if="isLoading" class="input-line-loading-placeholder shimmer big"></div>
    <div v-else class="input-wrapper" :class="[{ 'error' : error }, { 'with-label' : label }, {'display':this.display}]">
        <select class="input" :class="{ 'edited' : edited }" v-if="!display" :id="computedId" :required="required" :placeholder="placeholder" :disabled="disabled" v-model="inputValue" :style="backgroundColor ? 'background-color: ' + backgroundColor + ' !important;' : ''">
            <option v-if="defaultOption" :value="getValueForSelection(defaultItem)" >{{ defaultItem.displayname }}</option>
            <option v-for="option in optionList" :key="getValueForSelection(option)" :value="getValueForSelection(option)">{{ option.displayname }}</option>
        </select>
        
        <label v-else class="display">{{ selectedDisplay }}</label>

        <label class="input-label" :for="computedId" :class="{ 'with-content' : inputValue !== null && inputValue !== getValueForSelection(defaultItem) }" :style="backgroundColor ? 'background-color: ' + backgroundColor + ' !important;' : ''" v-if="label">{{ this.label }} {{ required ? '*' : '' }}</label>

        <div class="error-container">
            <label class="error-label" :class="{ 'show' : error }">{{ this.errorText }}</label>
        </div>
    </div>
</template>

<script>
const EMIT_INPUT = 'update:modelValue'

export default {
    name: 'dropdown-input',
    emits: [ EMIT_INPUT ],
    props: {
        modelValue: {
            type: [ Number, String ],
            required: true
        },
        defaultOptionId: {
            type: Number,
            default: -1
        },
        placeholder: {
            type: String,
            default: ' ' // is used to trigger the floating label so it can not be empty
        },
        edited: {
            type: Boolean,
            default: false
        },
        defaultOption: {
            type: Boolean,
            default: true
        },
        defaultLabel: {
            type: String,
            default: 'Bitte auswählen'
        },
        idForSelection: {
            // used if the displayid should not be used for the selection
            type: String,
            default: undefined
        },
        optionList: Array, // [] of "{displayid: 0, displayname: 'name', original: {object} }"
        label: String,
        required: Boolean,
        disabled: Boolean,
        display: Boolean,
        isLoading: Boolean,
        error: Boolean,
        errorText: String,
        backgroundColor: String,
        idStub: String,
        inputId: String
    },
    computed: {
        defaultItem() {
            const defaultItem = { displayid: this.defaultOptionId, displayname: '--- ' + this.defaultLabel + ' ---' }

            // if a different identifier is given, we add it to the default item with the defaultOptionId
            if (this.idForSelection) {
                defaultItem[this.idForSelection] = this.defaultOptionId
            }

            return defaultItem
        },
        computedId: function() {
            const externalId = this.inputId || ''
            const stub = this.idStub ? '-' + this.idStub : ''
            return `input-${externalId}${stub}`
        },
        inputValue: {
            get() {
                return this.modelValue
            },
            set(val) {
                this.$emit(EMIT_INPUT, this.getCurrentItem(val))
            }
        },
        selectedDisplay() {
            if (this.inputValue === this.defaultOptionId) return this.defaultItem.displayname
            else return this.optionList.filter(item => { this.getValueForSelection(item) === this.inputValue }).displayname
        },
    },
    methods: {
        getCurrentItem(displayid) {
            let selected

            if (displayid === this.defaultOptionId) {
                selected = this.defaultItem
            } else {
                selected = this.optionList.find(entry => this.getValueForSelection(entry) === displayid)
            }

            return selected
        },
        getValueForSelection(option) {
            if (this.idForSelection) {
                return option[this.idForSelection]
            } else {
                return option.displayid
            }
        }
    }
}
</script>

<style scoped>
.input-wrapper {
    position: relative;
}

.input-wrapper.with-label {
    padding-top: 15px;
}

.input-wrapper > .input-label {
    position: absolute;
    font-size: 1em;
    left: 10px;
    background: #fff;
    top: 6px;
    padding: 0px 5px;
    transition: .1s all;
    height: 10px;
    line-height: 10px;
}

.input-wrapper > .display {
    display: block;
    white-space: pre-wrap;
    text-align: left;
    padding-left: 10px;
    height: 30px;
    line-height: 30px;
    border-radius: var(--input-border-radius);
    border: 1px solid #ccc;
}

.input-wrapper > .input-label.with-content {
    top: 0px;
    left: 0px;
}

.input-wrapper > .search {
    position: absolute;
    border: 1px solid red;
    max-width: calc(100% - 20px);
    width: 150px;
    height: 30px;
}

select {
    width: 100%;
    height: 30px;
    box-sizing: border-box;
    font-size: 1.2em;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    background-color: #fff;
    border-radius: var(--input-border-radius);
    padding-left: 10px;
    border: 1px solid #064A6C;
}

select::placeholder {
    font-size: 1em;
}

select:disabled {
    border-color: #ddd;
    color: #000;
    cursor: not-allowed;
}

select.edited {
    border-color: green;
    border-width: 2px;
}

.textinput-container > label {
    color: #fff;
}

.input-label {
    font-size: 1.1em;
    color: #2c2e2f;
}

.error-container {
    min-height: 15px;
    margin-top: 3px;
    padding-left: 10px;
    color: red;
    text-align: left;
}

.error-container > .error-label {
    visibility: hidden;
}

.error-container > .error-label.show {
    visibility: visible;
}

.input-wrapper.error :deep(*) {
    color: red;
    border-color: red;
}

.input-wrapper.error > input {
    border: 1px solid red;
}
</style>